module.exports = __webpack_public_path__ + "img/手淘微详情6.1714d366.gif";